export default `/* Ids Notification Banner Component */
.ids-notification-banner {
  display: flex;
  position: relative;
  z-index: 2;
  padding-inline-start: var(--ids-notification-padding);
  align-items: center;
  min-height: var(--ids-notification-banner-height);
}

ids-alert,
.ids-alert {
  display: flex;
  margin-inline: var(--ids-notification-banner-padding);
}

ids-text::part(text),
.ids-text {
  color: var(--ids-notification-banner-color-text);
}

ids-hyperlink::part(link),
.ids-notification-banner-link a {
  color: var(--ids-color-action-stronger);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  margin: 0 var(--ids-notification-banner-padding);
}

.ids-notification-banner-button {
  display: flex;
  margin-inline-start: auto;
  padding-inline: var(--ids-space-2xs);
  margin-inline-end: var(--ids-notification-banner-button-padding);
}
.ids-notification-banner-button ids-button .ids-icon-button {
  justify-content: center;
  align-items: center;
}

ids-button::part(button):hover {
  background-color: var(--ids-notification-banner-button-color-background-hover);
}

.ids-notification-banner-message {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ids-notification-banner-message.wrap {
  white-space: unset;
  padding-block: var(--ids-space-12);
}

.ids-notification-banner[type=success],
.ids-notification-banner.success {
  background-color: var(--ids-notification-banner-success-color-background);
}

.ids-notification-banner[type=caution],
.ids-notification-banner.caution {
  background-color: var(--ids-notification-banner-caution-background-color);
}

.ids-notification-banner[type=warning],
.ids-notification-banner.warning {
  background-color: var(--ids-notification-banner-warning-color-background);
}

.ids-notification-banner[type=info],
.ids-notification-banner.info {
  background-color: var(--ids-notification-banner-info-color-background);
}

.ids-notification-banner[type=error],
.ids-notification-banner.error {
  background-color: var(--ids-notification-banner-error-color-background);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
